import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = typeof obj?.[key] === 'object' ? toCamelCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

const toSnakeCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toSnakeCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const snakeKey = key?.replace(/[A-Z]/g, letter => `_${letter?.toLowerCase()}`);
    acc[snakeKey] = typeof obj?.[key] === 'object' ? toSnakeCase(obj?.[key]) : obj?.[key];
    return acc;
  }, {});
};

export const notificationDatabaseService = {
  // Get notifications for current user
  async getMyNotifications() {
    const { data: { session } } = await supabase?.auth?.getSession();
    const user = session?.user;
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('notifications')?.select('*')?.eq('user_id', user?.id)?.order('created_at', { ascending: false });

    if (error) throw error;
    return toCamelCase(data);
  },

  // Mark notification as read
  async markAsRead(notificationId) {
    const { data: { session } } = await supabase?.auth?.getSession();
    const user = session?.user;
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('notifications')?.update({ is_read: true })?.eq('id', notificationId)?.eq('user_id', user?.id)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  // Mark all notifications as read
  async markAllAsRead() {
    const { data: { session } } = await supabase?.auth?.getSession();
    const user = session?.user;
    if (!user) throw new Error('Not authenticated');

    const { error } = await supabase?.from('notifications')?.update({ is_read: true })?.eq('user_id', user?.id)?.eq('is_read', false);

    if (error) throw error;
  },

  // Create notification
  async createNotification(notificationData) {
    const notificationPayload = toSnakeCase(notificationData);

    const { data, error } = await supabase?.from('notifications')?.insert(notificationPayload)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  // Subscribe to real-time notifications
  subscribeToNotifications(userId, callback) {
    const channelName = `notif-user-${userId}`;

    // أزل أي channel قديم بنفس الاسم قبل إنشاء اشتراك جديد
    try {
      const existing = supabase?.getChannels?.()?.find(
        (ch) => ch.topic === `realtime:${channelName}`
      );
      if (existing) supabase?.removeChannel(existing);
    } catch {}

    const channel = supabase
      ?.channel(channelName)
      ?.on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'notifications',
          filter: `user_id=eq.${userId}`,
        },
        (payload) => callback(toCamelCase(payload?.new))
      )
      ?.subscribe();

    return channel;
  },

  // Unsubscribe from notifications
  unsubscribeFromNotifications(channel) {
    if (channel) {
      supabase?.removeChannel(channel);
    }
  }
};